import React from "react";
import { Button, CircularProgress, Grow, Paper } from "@mui/material";
import { FaExclamationTriangle } from "react-icons/fa";
import { FaCircleInfo } from "react-icons/fa6";
import { acknowledgeNotification } from "../../api/notificationApi";
import { useSelector } from "react-redux";
import {FORMS, MODULES} from "../../const";

function NotificationComponent({ open, type = "success", message, onClose, loading, id, requestId, jobId, vehicleNo }) {
    const user = useSelector((state) => state.user);
    const transAuth = useSelector((state) => state.user.permissions[MODULES?.Transaction]);
    const actionCenterPermission = FORMS?.ACTION_CENTER?.ACTION_CENTER?.form;
    const headerActionCenter = actionCenterPermission ? transAuth?.[actionCenterPermission] : {};
    const viewActionCenterPermission = headerActionCenter?.NOTIFICATION?.VIEW;
    console.log("NotificationComponent", viewActionCenterPermission);

    const icon =
        type === "success" || type === "Info" ? (
            <FaCircleInfo color="#e74c3c" size={24} />
        ) : (
            <FaExclamationTriangle color="#e74c3c" size={24} />
        );

    const handleClick = async () => {
        try {
            const payload = {
                user: user.username,
                notId: id,
            };
            const response = await acknowledgeNotification(payload);

            if (response.status === 200) {
                onClose();
            }
        } catch (error) {
            console.error(error);
        }
    };

    return (
        viewActionCenterPermission && (
            <Grow in={open} timeout={300}>
                <Paper
                    elevation={6}
                    sx={{
                        width: "380px",
                        padding: "16px 24px",
                        borderRadius: "12px",
                        backgroundColor: "#fff0f0",
                        borderLeft: "6px solid #e74c3c",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        fontFamily: "'Segoe UI', sans-serif",
                        color: "#555",
                        display: "flex",
                        flexDirection: "column",
                        gap: "16px",
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <div style={{ fontSize: "24px", color: "#e74c3c" }}>
                            {icon}
                        </div>
                        <div>
                            <div style={{ fontWeight: 600, fontSize: "16px", color: "#c0392b" }}>
                                {type === "success" || type === "Info" ? "Information" : "Unauthorized Stop Detected"}
                            </div>
                            <div style={{ marginTop: "6px", fontSize: "14px", color: "#555" }}>
                                <div>{message}</div>
                            </div>
                        </div>
                    </div>

                    <div style={{ textAlign: "right" }}>
                        <Button
                            onClick={handleClick}
                            disabled={loading}
                            sx={{
                                padding: "8px 16px",
                                backgroundColor: "#e74c3c",
                                color: "#fff",
                                borderRadius: "6px",
                                fontWeight: 500,
                                textTransform: "none",
                                '&:hover': {
                                    backgroundColor: "#c0392b",
                                }
                            }}
                        >
                            {loading ? <CircularProgress size={20} sx={{ color: "#fff" }} /> : "Acknowledge"}
                        </Button>
                    </div>
                </Paper>
            </Grow>
        )
    );
}

export default NotificationComponent;
